import { useEffect } from 'react';


const useDetectDevTools = () => {
  useEffect(() => {

    const checkDevTools = () => {
      const start = performance.now();
      debugger;
      const end = performance.now();
      if (end - start > 100) {
        window.close();
      }
    };

    const intervalId = setInterval(checkDevTools, 1000);

    const preventContextMenu = (event) => {
      event.preventDefault();
    };

    const preventKeyboardShortcuts = (event) => {
      if (event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key === 'I')) {
        event.preventDefault();
        window.close();
      }
    };

    document.addEventListener('contextmenu', preventContextMenu);
    document.addEventListener('keydown', preventKeyboardShortcuts);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('contextmenu', preventContextMenu);
      document.removeEventListener('keydown', preventKeyboardShortcuts);
    };
  }, []);
};

export default useDetectDevTools;